import React, { Component } from 'react';
import './App.css';
import Navigation from './nav/nav';
import Cover from './cover/cover';
import { StickyContainer, Sticky } from 'react-sticky';
import  Gallery  from './content/gallery';
import  Map  from './content/map';
import  About  from './content/about';
import {Grid} from 'react-bootstrap';
import Kisfaludy from './content/kisfaludy';

class App extends Component {
  render() {
    return (
      <div className="App">
      
        <Cover opacity={0.4}/>
        
        <StickyContainer>
          <Sticky>
          {
            ({isSticky}) => <div style={{
              position: isSticky ? 'fixed': 'relative',
              top: 0,
              width: '100%',
              zIndex: 2,
              color: 'red'
            }}><Navigation /></div>
          }
          </Sticky>
          
            <Grid>
              <About />
              
              <Gallery />
              
              <Map />

              <Kisfaludy />

            </Grid>

        </StickyContainer>

      </div>
    );

  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js